import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFirestore } from 'angularfire2/firestore';
@Pipe({
  name: 'obtenerElementoDeUnidad'
})
export class ObtenerPropiedadDeUnidadPipe implements PipeTransform {
    constructor(public afs: AngularFirestore) { }
  transform(id: any, propiedad:any): any {
      if(id)
        return this.afs.collection('unidades').doc(id).valueChanges().take(1).map(unidad => unidad[propiedad]);
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-propiedad-de-unidad.pipe.ts